"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Backslash a user-provided string to make safe for use in a regex search.
 *
 * Provided by: https://stackoverflow.com/a/6969486
 */
exports.default = (str) => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};
